// Re-export from @lightwaves/image-optimizer package
// The package now natively supports onLoad and unoptimized props (v0.1.3+)
export { OptimizedImage as default, type OptimizedImageProps } from '@lightwaves/image-optimizer';
